import React from 'react';

const Banner = () => {
    return (
        <div  id='banner'>
            <img src={`${process.env.PUBLIC_URL}/banner.png`} alt="banniere de fond"/>
            <h2>Chez vous, partout&nbsp;et&nbsp;ailleurs</h2>
        </div>
    );
};

export default Banner;